import React from 'react';
import './UpdatesTodayNews.scss';
import DateText from '../texts/dateText/DateText';
import Category from '../category/Category';
import { useNavigate } from 'react-router-dom';

interface IUpdatesTodayNews {
  category: string;
  title: string;
  image: string;
  created_at: string;
  id: number;
}

const UpdatesTodayNews = ({ id, category, title, image, created_at }: IUpdatesTodayNews) => {
  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <Category value={category} />
      <div className="main">
        <div
          onClick={() => {
            navigate(`/news/${id}`);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="left cursor-pointer"
        >
          <span className="title">{title}</span>
        </div>
        <div className="right">
          <img width={140} height={100} className="img" src={image}></img>
          <DateText date={created_at} />
        </div>
      </div>
    </div>
  );
};

export default UpdatesTodayNews;
